module.exports = __webpack_public_path__ + "img/logo.9d9cb887.png";